<template>
    <div class="row mx-auto my-2 py-4">
        <div class="col-md-3 p-0 mx-auto">
            <component is="qrMaker"></component>
            <!--                <qr-generator></qr-generator>-->
        </div>
        <div class="col-md mx-auto p-3">
            <div class="row mx-auto">
                <v-expansion-panels class="px-1">
                    <v-expansion-panel class="mb-1">
                        <v-expansion-panel-header class="text-right">
                            اینستاگرام
                        </v-expansion-panel-header>
                        <v-expansion-panel-content class="py-4">
                            <v-text-field outlined
                                          v-model="data.domain"
                                          dense
                                          :rules="urlRules"
                                          @keypress="justEnglish($event)"
                                          maxLength="50"
                                          counter="50"
                                          placeholder="نام کاربری موردنظر خودرا وارد کنید."
                                          label="نام کاربری"
                                          append-icon="@"/>
                        </v-expansion-panel-content>
                    </v-expansion-panel>
                </v-expansion-panels>
            </div>
            <qr-generator></qr-generator>
        </div>
    </div>
</template>

<script>
import QrGenerator from "./qrGenerator";
import qrMaker from "./qrMaker";

export default {
    name: "qrInstagram",
    components: {QrGenerator,qrMaker},
    data() {
        return {
            data: {
                link: ''
            },
            urlRules: [
                (value) => this.isURL(value) || "لینک سایت باید بصورت https://terminalads.com یا terminalads.com وارد شود. ",
            ],
        }
    },
    methods: {
        isURL(str) {
            var regex = new RegExp("^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.){1}([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");
            if (regex.test(str) || without_regex.test(str)) {
                return true
            } else {
                return false;
            }
        },
        justEnglish(str) {
            const p = /^(\w|\.|\d)$/i;
            if (p.test(str.key)) {
                return str.key
            } else
                str.preventDefault();
        },
    }
}
</script>

<style scoped>

</style>